import apollo from 'apollo';
import { appsPerPage, clocksPerPage } from 'config';

import { AsyncActionHandler } from 'action-handler';
import { searchAllAppsQuery } from 'queries';
import {
  createNormalizedMap,
  handleFetchError,
  getNextPageKey,
  updatePages,
  hasNextPage,
  pushApps
} from 'action-utils';
import { setSearchInput } from 'actions/gallery';

const STATE_PROP = 'search';

export default new AsyncActionHandler({
  name: 'search_all_apps',
  stateProp: STATE_PROP,
  defaultState: {
    [STATE_PROP]: {},
    searchPages: {},
    apps: {}
  },
  handler(type, text, startIndex = 0) {
    return async (dispatch, getState) => {
      if (startIndex === 0) {
        dispatch(setSearchInput({ text, userSetInput: true, type }));
      }

      if (!text) {
        return;
      }

      const {
        [this.stateProp]: { [`${text}-${type}`]: { pages } = {} }
      } = getState().registry;

      const pageKey = getNextPageKey({
        index: startIndex,
        pages
      });

      if (startIndex !== 0 && !pageKey) {
        return;
      }

      try {
        const { data: { searchResults } = {} } = await apollo.query({
          query: searchAllAppsQuery,
          variables: {
            type,
            text,
            limit: type === 'CLOCK' ? clocksPerPage : appsPerPage,
            pageKey
          },
          fetchPolicy: 'no-cache'
        });

        return {
          type,
          text,
          searchResults,
          pageKey
        };
      } catch (error) {
        return handleFetchError(error);
      }
    };
  },
  reduce(state, { type, text, searchResults, pageKey = 0 }) {
    const {
      [this.stateProp]: { [`${text}-${type}`]: searchState = {} }
    } = state;

    if (!searchResults) {
      return state;
    }

    const existingApps = searchState.entries || [];
    const entries = pushApps(existingApps, searchResults.apps);

    const pages = updatePages({
      pageKey,
      pagedApps: searchResults,
      startIndex: existingApps.length,
      pages: searchState.pages
    });
    return {
      [this.stateProp]: {
        [`${text}-${type}`]: {
          entries,
          hasNextPage: hasNextPage(pages),
          pages
        }
      },
      apps: {
        ...state.apps,
        ...createNormalizedMap(searchResults.apps, state.apps)
      }
    };
  }
});
